import { useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getOrganizationList } from 'features/master-data/api/getOrganizationList';
import { useDebounce } from 'shared/hooks/useDebounce';

const LIMIT = 50;
const STALE_TIME = 5 * 60 * 1000;

const useOrganizationSelect = ({ isEnabled = true } = {}) => {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 400);

  const { data, isFetching: organizationLoading } = useQuery(
    ['organizations', debouncedSearch, page, LIMIT],
    () => getOrganizationList({ search: debouncedSearch, limit: LIMIT, page }),
    {
      enabled: isEnabled,
      staleTime: STALE_TIME,
      keepPreviousData: true,
      onSuccess: (res) => {
        const total = res?.meta?.total || 0;
        setHasMore(page * LIMIT < total);
      },
      onError: (e) => {
        toast.error(e?.response?.data?.errors?.[0]?.message || e.message);
      },
    }
  );

  const organizations = useMemo(() => {
    const dataArr = Array.isArray(data?.data) ? data.data : [];
    return dataArr.map((item) => ({
      ...item,
      label: item.name,
      value: item.id,
    }));
  }, [data]);

  const handleSearchOrganization = (val) => {
    setSearch(val);
    setPage(1);
  };

  const handleScrollOrganization = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      !organizationLoading &&
      hasMore &&
      scrollTop + clientHeight >= scrollHeight - 10
    ) {
      setPage((p) => p + 1);
    }
  };

  return {
    organizations,
    organizationLoading,
    handleSearchOrganization,
    handleScrollOrganization,
  };
};

export default useOrganizationSelect;
